import styled, { css } from 'styled-components';
import Image from '@components/image';
import LinkComponent from '@components/link';
import { headerHeight } from '@components/header/header.styled';
import { PhotographyHeroProps } from './index';

export const EyebrowWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    column-gap: 0.5rem;

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      justify-content: center;
    }

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      column-gap: 0.375rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      justify-content: flex-start;
    }
  `}
`;

export const StyledImage = styled(Image)`
  z-index: 1;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const TextContent = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: 1rem;
    padding-right: 4rem;
    align-items: flex-start;

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      padding-right: 3rem;
      align-items: flex-start;
    }

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      padding-right: 2.5rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      padding-right: 0rem;
    }
  `}
`;

export const Content = styled.div<PhotographyHeroProps>`
  ${({ theme, image }) => css`
    position: relative;
    display: flex;
    flex-direction: column;
    row-gap: 2.5rem;
    z-index: 1;
    width: 100%;
    min-height: 24rem;
    padding: 5rem 0;
    align-items: flex-start;

    @media only screen and (max-width: ${theme.breakpoints.xl}) {
      padding: 4rem 0;
      align-items: flex-start;
      min-height: 20rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      padding: 4rem 0;
      min-height: 20rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      padding: 3rem 0;
      align-items: flex-start;
      min-height: 8rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      min-height: 8rem;
    }

    ${image?.url
      ? css`
          justify-content: center;

          @media only screen and (max-width: ${theme.breakpoints.lg}) {
            align-items: flex-start;
          }

          @media only screen and (max-width: ${theme.breakpoints.sm}) {
            align-items: flex-start;
            row-gap: 2rem;
            padding: 2rem 0;
          }
        `
      : css`
          max-width: 52rem;
          align-items: center;
        `}
  `}
`;

export const Header = styled.header`
  ${({ theme }) => {
    return css`
      display: flex;
      position: relative;
      width: 100%;
      margin: 0;
      background-color: ${theme.backgroundColors.primary};
      padding-top: ${headerHeight};

      @media only screen and (max-width: ${theme.breakpoints.lg}) {
        padding-top: 5rem;
      }

      @media only screen and (max-width: ${theme.breakpoints.md}) {
        padding-top: 4rem;
      }
    `;
  }}
`;

export const StyledWrapper = styled.div<PhotographyHeroProps>`
  ${({ theme }) => css`
    display: flex;
    align-items: stretch;
    background-color: ${theme.backgroundColors.primary};
    gap: 0rem;
    padding: 0;

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
    }
  `}
`;

export const LinkButton = styled(LinkComponent)<PhotographyHeroProps>`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    color: ${theme.colors.black};

    &:hover {
      background-color: ${theme.colors.secondary};
      color: ${theme.colors.white};
    }
  `}
`;

export const ImageWrapper = styled.div`
  ${({ theme }) => css`
    gap: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    position: relative;
    width: calc(100% + 2rem);
    overflow: hidden;
    margin-right: -1rem;

    .animate-wrapper {
      height: 100%;
    }

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      justify-content: flex-start;
      width: 100vw;
      margin-right: 0;
      align-self: center;
      max-height: 18rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      align-self: center;
    }
  `}
`;
